import React from 'react';

import styles from './DeliveryMethod.module.css'
import {cn} from "../../../../../../../utils/cn.ts";
import {Icon} from "../../../../../../../ui/General/Icon/Icon.tsx";
import {DeliveryType} from "../../../../../../../types/Delivery.interface.ts";
import { OrderDeliveryType } from '../../../../../../../utils/getOrderDeliveryType.ts';
import { Order } from '../../../../../../../types/Order.interface.ts';
interface Props {
    deliveryType: string
    changeType: (type: string) => void,
    offer: Order
}

export const DeliveryMethods: React.FC<Props> = ({deliveryType, changeType, offer}) => {
    const isPodzamenuPickup = deliveryType === DeliveryType.pickup;
    const isPodzamenuCourier = deliveryType === DeliveryType.courier;
    const isOthers = deliveryType === DeliveryType.shipping;
    const orderDeliveryType = deliveryType === 'transport_company' ? OrderDeliveryType.transport_company : OrderDeliveryType.in_town;

    return (<ul className={styles.deliveryMethods}>
        {
                        orderDeliveryType === OrderDeliveryType.in_town
                            ? <li
                            className={cn(
                                styles.deliveryMethod,
                                isPodzamenuCourier && styles.deliveryMethodChosen
                            )}
                                onClick={() => changeType(DeliveryType.courier)}
                            >
                                <Icon name='van' width={36} height={30} color={isPodzamenuCourier ? '#F39200' : '#cdcdcd'}/>
                                <div className={styles.type}>
                                    <div className={styles.typeName}>
                                        Доставка курьером
                                    </div>
                                    {
                                        offer.delivery.courierPrice
                                            ? <div className={styles.typeInfo}>
                                                стоимость {offer.delivery.courierPrice} ₽
                                            </div>
                                            : <div className={styles.typeInfo}>
                                                 расчитать стоимость
                                            </div>
                                    }
                                </div>
                            </li>
                            : null
                    }
                    {
                        orderDeliveryType === OrderDeliveryType.in_town
                            ?
                            <li
                            className={cn(
                                styles.deliveryMethod,
                                isPodzamenuPickup && styles.deliveryMethodChosen
                            )}
                                onClick={() => changeType(DeliveryType.pickup)}
                            >
                                <Icon name='geo-marker' width={23} height={31}
                                      color={isPodzamenuPickup ? '#F39200' : '#cdcdcd'}/>
                                <div className={styles.type}>
                                    <div className={styles.typeName}>
                                        Самовывоз
                                    </div>
                                    <div className={styles.typeInfo}>
                                        {offer.accessibilityBranches.length} ПВ
                                    </div>
                                </div>
                            </li>
                            : null
                    }
                    {
                        orderDeliveryType === OrderDeliveryType.transport_company
                            ?
                            <li
                                className={cn(
                                    styles.deliveryMethod,
                                    isPodzamenuPickup && styles.deliveryMethodChosen
                                )}
                                onClick={() => changeType(DeliveryType.shipping)}
                            >
                                <Icon name='box' width={23} height={31} color={isOthers ? '#F39200' : '#cdcdcd'}/>
                                <div className={styles.type}>
                                    <div className={styles.typeName}>
                                        Транспортная компания
                                    </div>
                                </div>
                            </li>
                            : null
                    }
    </ul>);
};